import {cdmMw} from '../api';

export default {
    api: cdmMw,
    url: 'api/intraday-update-modes',
    useCache: false,
    parseResponse: ({data}) => data,
    defaultValue: {}
};
